import { useUserFeedbackFiltersContext } from '../context/UserFeedbackFiltersContext';
import useGetUserFeedbackQuery from '../queries/useGetUserFeedbackQuery';

const useFetchUserFeedback = () => {
  const { userFeedbackFilters } = useUserFeedbackFiltersContext();
  const { data, isLoading, error, refetch } =
    useGetUserFeedbackQuery(userFeedbackFilters);

  return { data, isLoading, error, refetch };
};

export default useFetchUserFeedback;
